const FlatTheme = {
  Page: {
    classes: {
      root: ""
    }
  },
  BottomNavigation: {
    classes: {
      root: "",
      container: "h-[56px] px-[10px] flex items-center justify-between bg-bottomMenu"
    }
  },
  BottomNavigationAction: {
    classes: {
      root: "h-[56px] w-[56px]",
      label: "transition-[color,font-weight] text-content-soft text-[12px] leading-3 mt-1 mb-[10px]",
      indicator: "opacity-0 h-[1px] rounded-t-sm transition-opacity bg-content-base shadow-[0px_-1px_8px_0px_rgba(184,195,255,0.25)]",
      indicatorShadow: "opacity-0 transition-opacity bg-[linear-gradient(180deg,_rgba(147,120,255,0)_0%,rgba(147,120,255,0.25)_100%)]",
      // Variants: primary
      root_primary: `!h-[90px] !justify-start pt-4 w-[90px] rounded-full -translate-y-[8px] self-end
        shadow-[0px_8px_8px_0px_#00000054,0px_8px_16px_0px_#00000026,4px_4px_8px_0px_#FFFFFF40_inset,-4px_-4px_16px_0px_#00000080_inset]
        `,
      "root_primary:active": `!h-[90px] !justify-start pt-4 w-[90px] rounded-full -translate-y-[8px] self-end
        shadow-[0px_8px_8px_0px_#00000054,0px_8px_16px_0px_#00000026,4px_4px_8px_0px_#FFFFFF40_inset,-4px_-4px_16px_0px_#00000080_inset]
        `,
      label_primary: "text-[18px] drop-shadow-[#00000040] font-semibold text-content-soft line-height-[22px]",
      // Variants: normal
      "label_normal:active": "font-bold text-content-base",
      "indicator_normal:active": "opacity-100",
      "indicatorShadow_normal:active": "!opacity-50"
    }
  },
  // Inputs
  TextField: {
    classes: {
      root: `w-full`,
      input: `text-content-base bg-darkBrand-800 placeholder-content-soft border-stroke-base border focus:border-accentBrand-400 outline-0 px-4 w-full`,
      "input:sm": "h-[44px] text-base leading-5 rounded-md",
      "input:md": "h-[48px] text-base leading-5 rounded-md",
      "input:lg": "h-[50px] text-base leading-5 rounded-md",
      "input:xl": "h-[50px] text-2xl leading-5 rounded-md",
      iconContainer: "absolute",
      "iconContainer:sm": "left-2 top-2 mr-2 max-h-6 max-w-6",
      "iconContainer:md": "left-3 top-2 mr-2 max-h-6 max-w-6",
      "iconContainer:lg": "left-4 top-3 mr-2 max-h-8 max-w-8",
      "iconContainer:xl": "left-4 top-4 mr-2 max-h-8 max-w-8",
      // Variants: normal
      // Variants: disabled
      input_disabled: "opacity-60 cursor-not-allowed",
      // Variants: error
      input_error: "border-error-base"
    }
  },
  CodeField: {
    classes: {
      root: "",
      input: "appearance-none",
      input_ghost: "!border-0 !border-b-2 !rounded-none ![background:unset]"
    }
  },
  NumberField: {
    classes: {
      root: "",
      inputContainer: "relative text-white flex w-full flex-row items-center border-stroke-base border focus-within:border-accentBrand-400 bg-darkBrand-800 px-4 outline-0",
      "inputContainer:sm": "h-[50px] rounded-md text-2xl",
      "inputContainer:md": "h-[50px] rounded-md text-2xl",
      "inputContainer:lg": "h-[50px] rounded-md text-2xl",
      inputContainerError: "!border-error-base",
      currency: "absolute text-base text-content-soft"
    }
  },
  FieldHelperText: {
    classes: {
      root: "text-xs mt-1 leading-4 text-right transition-[max-height]",
      helperText: "text-content-soft",
      errorText: "text-error-base"
    }
  },
  FieldLabel: {
    classes: {
      root: "mb-0.5 text-sm leading-[21px] inline-block transition-colors text-content-base",
      error: "text-error-base"
    }
  },
  Button: {
    classes: {
      root: "transition-all duration-200 will-change-auto w-full flex justify-center items-center disabled:pointer-events-none",
      "root:sm": "h-[26px] text-[12px] leading-[16px] rounded-md",
      "root:md": "h-[40px] text-base leading-[19px] rounded-lg",
      "root:lg": "h-[50px] text-base leading-[19px] rounded-lg",
      "root:xl": "h-[70px] text-lg leading-6 rounded-lg",
      spinner: "text-accentBrand-200",
      "spinner:sm": "h-4 w-4",
      "spinner:md": "h-5 w-5",
      "spinner:lg": "h-6 w-6",
      "spinner:xl": "h-10 w-10",
      label: "flex items-center justify-center gap-x-2 font-bold",
      // Variants: primary
      root_primary: `
        bg-grdPrimary
        active:bg-grdPrimaryAlt
        disabled:bg-accentBrand-600 disabled:opacity-40 disabled:[background-image:none]
      `,
      label_primary: "text-content-base drop-shadow-[1px_0px_2px_rgba(0,0,0,0.60)]",
      // Variants: secondary
      root_secondary: `
        bg-darkBrand-700
        active:bg-darkBrand-800
        disabled:opacity-50
      `,
      label_secondary: "text-content-base [text-shadow:1px_1px_0px_rgba(0,0,0,0.25)]",
      // Variants: danger
      root_danger: `
        bg-error-base
        active:bg-error-700
        disabled:opacity-40
      `,
      label_danger: "drop-shadow-[1px_0px_2px_rgba(0,0,0,0.60)] text-[#EBE9FF]",
      // Variants: yellow
      root_yellow: `
        bg-[#E8BC89]
        active:bg-[#E09F64]
        disabled:opacity-50
      `,
      label_yellow: `text-[#6C3722]`,
      // Variants: contained
      root_contained: `
        bg-darkBrand-800
        border-stroke-base
        border
        disabled:opacity-40
      `,
      // Variants: green
      root_green: `
        bg-success-600
        active:bg-success-800
        disabled:opacity-40
      `,
      label_green: "text-content-base drop-shadow-[1px_0px_2px_rgba(0,0,0,0.60)]",
      //Variant: pink
      root_pink: `
      bg-[#EA1865]
      active:bg-[#EA1865]
      disabled:opacity-40
    `,
      label_pink: "text-white drop-shadow-[1px_0px_2px_rgba(0,0,0,0.60)]",
      // Variants: bordered
      root_bordered: `
      bg-transparent
      border-2 border-stroke-base
      active:border-stroke-strong
      disabled:opacity-40`,
      label_bordered: "text-content-base",
      // Shiny effect
      shinyWrapper: "overflow-hidden",
      "shinyWrapper:sm": "rounded-md",
      "shinyWrapper:md": "rounded-lg",
      "shinyWrapper:lg": "rounded-lg",
      "shinyWrapper:xl": "rounded-lg",
      shiny: "w-[190px] pointer-events-none h-full bg-[linear-gradient(110deg,_rgba(255,_255,_255,_0.00)_25.38%,_rgba(255,_255,_255,_0.75)_53.96%,_rgba(255,_255,_255,_0.00)_83.85%)]"
    }
  },
  ButtonIcon: {
    classes: {
      root: "transition-all duration-200 will-change-auto flex justify-center items-center disabled:pointer-events-none",
      "root:sm": "h-5 w-5 rounded",
      "root:md": "h-8 w-8 rounded-md",
      "root:lg": "h-11 w-11 rounded-md",
      "icon:sm": "h-3.5 w-3.5",
      "icon:md": "h-6 w-6",
      "icon:lg": "h-6 w-6",
      // Variants: contained
      root_contained: `
        bg-darkBrand-700
        active:bg-darkBrand-600
        disabled:opacity-40
      `,
      // Variants: ghost
      root_ghost: `
        text-content-base
        active:text-content-soft
        disabled:opacity-50
      `
    }
  },
  Drawer: {
    classes: {
      root: "fixed top-0 left-0 z-20 h-full w-full overflow-y-hidden flex flex-col",
      backDrop: "absolute blur top-0 left-0 h-full w-full z-[21] bg-backdrop transition duration-300 data-[closed]:opacity-0 ",
      drawerTop: "flex h-8 justify-center",
      drawerBody: "",
      container: "z-[22] border-t border-stroke-base max-h-[calc(100dvh-40px)] flex flex-col w-full rounded-t-[20px] bg-dialog",
      safeZone: "pb-8 px-5",
      // Variants: full-screen
      "container_full-screen": "!max-h-dvh h-full !rounded-none transition-all"
    }
  },
  DrawerTitle: {
    classes: {
      root: "my-4",
      title: "text-[28px] font-bold leading-[34px] text-content-base",
      "title:sm": "text-[18px] leading-[22px]",
      "title:md": "text-[22px] leading-[27px]",
      "title:lg": "text-[28px] leading-[34px]",
      subTitle: "text-center text-sm tracking-[-0.6px] text-content-soft",
      backButtonWrapper: "left-0 top-0",
      closeButtonWrapper: "right-0 top-0"
    }
  },
  PageTitle: {
    classes: {
      root: "",
      root_solid: "pb-2 pt-2",
      label: "text-[22px] font-semibold leading-[27px] inline-block content-base will-change-transform",
      labelOverlay: "will-change-transform",
      star: "",
      // Variants: gradient-yellow
      "root_gradient-yellow": "pb-1",
      "label_gradient-yellow": `inline-block h-[35px] w-fit text-center text-[26px] font-bold leading-[34px] text-[#6420A9] [-webkit-text-stroke:0.5px_rgb(100,_32,_169)] [text-shadow:0_-2px_#fdf3c8,0px_2px_4.3px_rgba(0,0,0,0.20),0px_1px_0px_#6420A9]`,
      "labelOverlay_gradient-yellow": `inline-block h-[35px] w-fit  bg-[radial-gradient(73.07%_107.87%_at_50.18%_1.14%,_#F7D452_0%,_#BA83FD_100%)] bg-clip-text text-center text-[26px] font-bold leading-[34px] text-transparent`,
      "star_gradient-yellow": "",
      // Variants: gradient-purple
      "root_gradient-purple": "",
      "label_gradient-purple": "text-darkBrand-600 pt-[1px] pl-[0.5px] text-2xl font-bold leading-8 [text-shadow:0px_2px_0px_rgba(0,0,0,0.20),0px_1px_0px_currentColor] [-webkit-text-stroke:0.5px_currentColor]",
      "labelOverlay_gradient-purple": "text-2xl font-bold leading-8 bg-pageTitle bg-clip-text text-transparent",
      // Variants: gradient
      root_gradient: "",
      label_gradient: "text-darkBrand-600 pt-[1px] pl-[0.5px] text-2xl font-bold leading-8 [text-shadow:0px_2px_0px_rgba(0,0,0,0.20),0px_1px_0px_currentColor] [-webkit-text-stroke:0.5px_currentColor]",
      labelOverlay_gradient: "text-2xl font-bold leading-8 bg-pageTitle bg-clip-text text-transparent"
    }
  },
  CopyWrapper: {
    classes: {
      root: "bg-[rgba(255,255,255,0.1)] rounded-lg",
      icon: "m-1 mr-0 bg-[rgba(0,0,0,0.25)] rounded-lg p-1",
      label: "m-1.5 text-lg font-semibold bg-[linear-gradient(180deg,#F3F3FF_12.82%,#B8BAFB_58.21%)] inline-block text-transparent bg-clip-text"
    }
  },
  Checkbox: {
    classes: {
      root: "h-fit w-fit flex justify-center items-center",
      input: "appearance-none rounded-full",
      symbol: "pointer-events-none [filter:drop-shadow(0.5px_1px_0px_rgba(0, 0, 0, 0.40)]",
      "symbol:sm": "h-[18px] w-[18px]",
      "symbol:md": "h-[18px] w-[18px]",
      "symbol:lg": "h-[18px] w-[18px]",
      "input:sm": "!h-[22px] !w-[22px]",
      "input:md": "!h-[22px] !w-[22px]",
      "input:lg": "!h-[22px] !w-[22px]",
      "root:sm": "!h-8 w-8 ",
      "root:md": "!h-8 w-8",
      "root:lg": "!h-8 w-8",
      input_filled: "border-stroke-base checked:bg-darkBrand-600 border-2 ",
      input_outlined: "checked:border-stroke-base border-stroke-base border-2"
    }
  },
  BackButton: {
    classes: {
      root: "w-[40px] h-[40px] transition ease-in-out delay-150",
      root_circular: `border border-[#3a2765] rounded-full
      bg-[radial-gradient(50%_100%_at_50%_0%,rgba(81,79,144,0.16)_0%,rgba(63,62,112,0.16)_100%)]
      hover:bg-[radial-gradient(50%_100%_at_50%_0%,rgba(81,79,144,0.25)_0%,rgba(63,62,112,0.25)_100%)]
      active:bg-[radial-gradient(50%_100%_at_50%_0%,rgba(81,79,144,0.35)_0%,rgba(63,62,112,0.35)_100%)]
      shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]`,
      root_squared: "rounded-lg bg-[rgba(0,0,0,0.25)] active:bg-[rgba(0,0,0,0.45)] hover:bg-[rgba(0,0,0,0.35)]",
      icon: "bg-transparent mx-auto"
    }
  },
  LanguageSelector: {
    classes: {
      root: "flex items-center w-full px-2",
      "root:sm": "h-5 w-5 rounded",
      "root:md": "h-8 w-8 rounded-md",
      "root:lg": "h-11 w-11 rounded-md",
      arrow: "text-[#B3A2D7]",
      "arrow:sm": "w-2 h-2 ml-auto",
      "arrow:md": "w-3 h-3 ml-auto",
      "arrow:lg": "w-3 h-3 ml-auto",
      "arrow:xl": "w-3 h-3 ml-auto",
      label: "text-[#EBE9FF] mr-2",
      "label:sm": "text-sm",
      "label:md": "text-sm",
      "label:lg": "text-sm",
      flag: "object-cover object-center rounded-full",
      "flag:sm": "w-5 h-5",
      "flag:md": "w-5 h-5",
      "flag:lg": "w-5 h-5",
      "flag:xl": "w-5 h-5"
    }
  },
  List: {
    classes: {
      root: "rounded-md bg-white bg-opacity-[0.04] border border-[#FFFFFF0F] divide-y divide-[#FFFFFF14]"
    }
  },
  Select: {
    classes: {
      root: "flex w-full flex-col gap-2",
      label: "text-content-base text-xl font-bold",
      select: "text-content-base bg-darkBrand-800 placeholder-content-secondary border-stroke-base border focus:border-accentBrand-400  outline-0 px-4",
      "select:sm": "h-[40px] text-base leading-5 rounded-md",
      "select:md": "h-[48px] text-base leading-5 rounded-md",
      "select:lg": "h-[50px] text-base leading-5 rounded-md",
      "select:xl": "h-[50px] text-2xl leading-5 rounded-md",
      optionsContainer: "mt-2 w-[var(--button-width)] origin-top rounded-lg bg-darkBrand-800 transition duration-200 ease-out data-[closed]:scale-95 data-[closed]:opacity-0 z-30 shadow-[0px_8px_16px_0px_rgba(0,0,0,0.25)]",
      option: "text-content-base px-4 py-2 text-left text-base active:bg-white active:bg-opacity-5",
      selectedOption: "font-medium",
      errorText: "text-error-base",
      helperText: "text-content-soft text-sm my-1 text-right px-2",
      iconDropdown: "w-[16px] h-[16px] text-content-base",
      disabledOption: "opacity-50 cursor-not-allowed",
      selectContent: "flex items-center gap-2",
      selectContentContainer: "flex w-full items-center justify-between"
    }
  },
  Dialog: {
    classes: {
      root: "focus:outline-none",
      backDrop: "fixed inset-0 bg-backdrop backdrop-blur z-10",
      containerWrapper: "fixed inset-0 flex w-screen items-center justify-center p-4 z-[11]",
      container: "data-[closed]:transform-[scale(95%)] shadow-[0px_-8px_24px_0px_rgba(0,0,0,0.50)] w-full max-w-sm rounded-md border-1 border-white/10 bg-dialog p-4 duration-300 ease-out data-[closed]:opacity-0 z-[12]",
      title: "text-content-base mb-2.5 text-center text-lg leading-7 font-semibold"
    }
  },
  Transaction: {
    classes: {
      root: "p-4",
      label: "text-sm font-bold text-content-base inline-block",
      timestamp: "text-xs font-normal text-content-base",
      currency: "text-sm leading-4",
      amount: "text-sm font-bold leading-5",
      amount_positive: "text-success-base",
      amount_negative: "!text-error-base",
      extraSubtitle: "text-content-soft text-xs mt-1",
      idLabel: "text-content-soft text-xs leading-4"
    }
  },
  StatusChip: {
    classes: {
      root: "h-[18px] relative border flex items-center border-stroke-base rounded-[4px] w-fit px-2 py-0",
      label: "text-[10px] leading-4 inline-block text-content-base",
      dot: "w-1.5 h-1.5 flex-shrink-0 rounded-full mr-1.5",
      dot_green: "bg-success-base",
      dot_yellow: "bg-warning-base",
      dot_blue: "bg-informative-base",
      dot_rose: "bg-error-base",
      dot_gray: "bg-darkBrand-400",
      "dot_pending-audit": "bg-darkBrand-500"
    }
  },
  Card: {
    classes: {
      root: "bg-card",
      "root:sm": "rounded-sm",
      "root:md": "rounded-md",
      "root:lg": "rounded-lg",
      "root:xl": "rounded-2xl",
      root_primary: "border border-white border-opacity-10"
    }
  },
  TabNavigation: {
    classes: {
      root: "flex gap-1.5",
      "root:horizontal": "flex-row",
      "root:vertical": "flex-col",
      tab: "flex-shrink-0",
      underlinedWrapper: "",
      tabButton: ""
    }
  },
  SelectOptions: {
    classes: {
      image: "max-h-12 object-center object-contain",
      image_circular: "h-8 w-8 flex-shrink-0 rounded-full border border-[rgba(255,255,255,0.25)] object-cover object-center"
    }
  },
  EmptyState: {
    classes: {
      root: "flex flex-col justify-center items-center rounded-md bg-white bg-opacity-[0.03] border border-[rgba(255,255,255,0.10)] shadow-[0px_8px_16px_0px_rgba(0,0,0,0.10)]",
      title: "text-content-soft",
      subTitle: "text-content-soft",
      // Variants: sm
      "root:sm": "py-4 px-4 rounded-sm",
      "title:sm": "text-sm",
      "subTitle:sm": "text-xs",
      // Variants: md
      "root:md": "py-4 px-4 rounded-md",
      "title:md": "text-sm",
      "subTitle:md": "text-xs",
      // Variants: lg
      "root:lg": "py-4 px-4 rounded-md",
      "title:lg": "text-base",
      "subTitle:lg": "text-xs"
    }
  },
  Skeleton: {
    classes: {
      root: "animate-pulse bg-darkBrand-800 rounded-md w-full h-full"
    }
  },
  Prompt: {
    classes: {
      root: "",
      content: "mb-4 text-center text-sm leading-5 text-content-base"
    }
  }
};
export {
  FlatTheme
};
